import template from './hueb-seo-robots.html.twig';

const { Component, Mixin } = Shopware;
const { Criteria } = Shopware.Data;

Component.register('hueb-seo-robots', {
    template,

    inject: ['repositoryFactory'],

    mixins: [Mixin.getByName('notification')],

    data() {
        return {
            robotsTagRepository: null,
            options: [],
            selected: '00',
        }
    },

    props: {
        data: {
            type: Object,
            required: true
        },
    },

    watch: {
        'data.id': function (newId) {
            if (newId) {
                this.getRobotsTag(newId);
            }
        }
    },

    created() {
        this.createdComponent();
        if (this.data?.id) {
            this.getRobotsTag(this.data?.id);
        }
    },

    methods: {
        createdComponent() {
            this.robotsTagRepository = this.repositoryFactory.create('hueb_seo_ultimate_robot_tags');
            this.options = [{value: '00', label: this.$tc('hueb-seo.card.robot00')},
                            {value: '01', label: this.$tc('hueb-seo.card.robot01')},
                            {value: '10', label: this.$tc('hueb-seo.card.robot10')},
                            {value: '11', label: this.$tc('hueb-seo.card.robot11')}];
        },
        onChange() {
            if (this.selected) {
                    let entity = this.robotsTagRepository.create(Shopware.Context.api);

                    entity.id = this.data.id;
                    if (this.selected === '01') {
                        entity.noindex = false;
                        entity.nofollow = true;
                    } else if (this.selected === '10') {
                        entity.noindex = true;
                        entity.nofollow = false;
                    } else if (this.selected === '11') {
                        entity.noindex = true;
                        entity.nofollow = true;
                    } else {
                        entity.noindex = false;
                        entity.nofollow = false;
                    }
                this.robotsTagRepository.sync([entity], Shopware.Context.api);
            }
            //this.$emit('change', this.selected);
        },
        getRobotsTag(id) {
            this.robotsTagRepository.get(id, Shopware.Context.api)
                .then((entry) => {
                    if (entry) {
                        const noindex = entry.noindex ? 1 : 0;
                        const nofollow = entry.nofollow ? 1 : 0;
                        this.selected = noindex.toString() + nofollow.toString();
                    } else {
                        this.selected = '00';
                    }
                });
        }
    }
});
